import { MutationTree } from 'vuex';

import { State } from './state';
import { MenuMutationTypes } from './mutation-types';

export type Mutations<S = State> = {
    [MenuMutationTypes.SET_CONTRATO](state: S, contrato: number): void;
    [MenuMutationTypes.SET_CODIGOESCOLA](state: S, codigoEscola: number): void;
    [MenuMutationTypes.SET_CODIGOGRUPOUSUARIO](state: S, codigoGrupo: number): void;
    [MenuMutationTypes.SET_CODIGOPROFESSOR](state: S, codigoProfessor: number): void;
    [MenuMutationTypes.SET_CODIGORESPONSAVEL](state: S, codigoResponsavel: number): void;
    [MenuMutationTypes.SET_CODIGOALUNO](state: S, codigoAluno: number): void;
    [MenuMutationTypes.SET_CODIGOUSUARIO](state: S, codigoUsuario: number): void;
    [MenuMutationTypes.SET_ANO](state: S, ano: number): void;
    [MenuMutationTypes.SET_SEMESTRE](state: S, semestre: number): void;
    [MenuMutationTypes.SET_READONLY](state: S, readOnly: number): void;
    [MenuMutationTypes.SET_CHAMADA_VIA_PROXY](state: S, chamadaViaProxy: boolean): void;
    [MenuMutationTypes.SET_CODIGOENSINO](state: S, ensino: number): void;
}

export const mutations: MutationTree<State> & Mutations = {
    [MenuMutationTypes.SET_CONTRATO](state: State, contrato: number) {
        state.codigoContrato = contrato;
    },
    [MenuMutationTypes.SET_CODIGOESCOLA](state: State, codigoEscola: number) {
        state.codigoEscola = codigoEscola;
    },
    [MenuMutationTypes.SET_CODIGOGRUPOUSUARIO](state: State, codigoGrupo: number) {
        state.codigoGrupo = codigoGrupo;
    },
    [MenuMutationTypes.SET_CODIGOPROFESSOR](state: State, codigoProfessor: number) {
        state.codigoProfessor = codigoProfessor;
    },
    [MenuMutationTypes.SET_CODIGORESPONSAVEL](state: State, codigoResponsavel: number) {
        state.codigoResponsavel = codigoResponsavel;
    },
    [MenuMutationTypes.SET_CODIGOALUNO](state: State, codigoAluno: number) {
        state.codigoAluno = codigoAluno;
    },        
    [MenuMutationTypes.SET_CODIGOUSUARIO](state: State, codigoUsuario: number) {
        state.codigoUsuario = codigoUsuario;
    },
    [MenuMutationTypes.SET_ANO](state: State, ano: number) {
        state.ano = ano;
    },
    [MenuMutationTypes.SET_SEMESTRE](state: State, semestre: number) {
        state.semestre = semestre;
    },
    [MenuMutationTypes.SET_READONLY](state: State, readOnly: number) {
        state.readOnly = readOnly;
    },
    [MenuMutationTypes.SET_CHAMADA_VIA_PROXY](state: State, chamadaViaProxy: boolean) {
        state.chamadaViaProxy = chamadaViaProxy;
    },
    [MenuMutationTypes.SET_CODIGOENSINO](state: State, codigoEnsino: number) {
        state.codigoEnsino = codigoEnsino;
    },
};
